import { POLICY_STATUSES } from '../utils/constants';

export const RENEWALS_WINDOW_DAYS = 30;

export const RENEWAL_STATUS_COLORS = Object.freeze({
  [POLICY_STATUSES.ACTIVE.name]: 'success',
  [POLICY_STATUSES.FINISHED.name]: 'warning',
  [POLICY_STATUSES.CANCELED.name]: 'danger',
  [POLICY_STATUSES.OVERDUE.name]: 'warning',
  [POLICY_STATUSES.INACTIVE.name]: 'dark',
  [POLICY_STATUSES.OPEN.name]: 'primary',
});
